import { useFormContext } from "react-hook-form";
import { EmailFieldProps } from "./Email.types";
import { FormControl, FormDescription, FormField, FormItem, FormMessage } from "@shadcn/components/ui/form";
import { Input } from "@shadcn/components/ui/input";
import { Label } from "@shadcn/components/ui/label";
import { getValidationConfig } from "@forms/form-render/helpers/getValidationConfig";
import { getFieldHelperText } from "@forms/form-render/helpers/getFieldHelperText";
import { Mail } from "lucide-react";

export const Email = ({ label, name, required, validation, config, disabled }: EmailFieldProps) => {
  const { control } = useFormContext();
  const validationConfig = getValidationConfig(validation);
  const description = getFieldHelperText(config.helperText, required);

  return (
    <FormField
      control={control}
      defaultValue={config.defaultValue}
      rules={{
        ...validationConfig,
        required: {
          value: required,
          message: "This is a required field",
        },
        pattern: {
          value:
            /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
          message: "Please enter a valid email address",
        },
      }}
      name={name}
      render={({ field }) => (
        <FormItem className="space-y-2">
          {label && <Label htmlFor={name}>{label}</Label>}
          <FormMessage />
          <FormControl>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground pointer-events-none" />
              <Input
                {...field}
                id={name}
                type="email"
                placeholder={config.placeholder}
                disabled={disabled}
                aria-label={label}
                className="pl-9"
              />
            </div>
          </FormControl>
          {description && <FormDescription>{description}</FormDescription>}
        </FormItem>
      )}
    />
  );
};
